/**
 * Selection-checkbox styling for DataMan's bulk-selection controls (row,
 * select-all and the virtualized-row variant), aligned to the queue mockup:
 * 16px box, 1.5px #c7ced4 border, 5px radius, white fill and a 0.11s ease
 * transition on background/border-color. Layered over the shared
 * `primitives/checkbox` base via `cn`, so the checked state (black fill) is
 * left untouched.
 */
export const DATA_MAN_CHECKBOX_CLASS =
  "rounded-[5px] border-[1.5px] border-[#c7ced4] bg-white transition-[background,border-color] duration-[110ms]";
